import React from 'react';

import DataBlock from '../data-block/DataBlock';
import CommonPage from '../../../components/common-page/CommonPage';
import ConceptCompareSection from './components/concept-compare-section/ConceptCompareSection';
import FilterSection from '../filter-section/FilterSection';
import ConceptH2H from './components/concept-h2h/ConceptH2H';
import AudienceFilters from '../audience-filters/AudienceFilters';

import scss from './ConceptResponse.module.scss';

function ConceptResponse() {
  return (
    <CommonPage className={scss.pageWrapper}>
      <DataBlock />

      <FilterSection filters={AudienceFilters}>
        {({ appliedFilters }) => (
          <div className={scss.conceptResponse}>
            <ConceptCompareSection appliedFilters={appliedFilters} />
            <ConceptH2H appliedFilters={appliedFilters} />
          </div>
        )}
      </FilterSection>
    </CommonPage>
  );
}

export default ConceptResponse;
